(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-bake-day"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-bake-day')) {
    class TbBakeDay extends HTMLElement {
      connectedCallback() {
        const names = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const cutoff = parseInt(this.dataset.cutoff, 10);
        const now = new Date();
        const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
        this.querySelectorAll('input[data-day]').forEach((input) => {
          const target = names.indexOf(input.dataset.day.toLowerCase());
          if (target < 0) return;
          const date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          for (let i = 0; i < 15; i += 1) {
            if (date.getDay() === target) {
              const deadline = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, isNaN(cutoff) ? 18 : cutoff);
              if (now < deadline) break;
            }
            date.setDate(date.getDate() + 1);
          }
          const label = fmt.format(date);
          input.value = `${input.dataset.day}, ${label}`;
          const slot = input.parentElement.querySelector('[data-date]');
          if (slot) slot.textContent = label;
        });
      }
    }
    customElements.define('tb-bake-day', TbBakeDay);
  }
  } catch(e) { console.error(e); }
})();

})();
